import React from 'react'

import Form from '../../atoms/form/Form'
import Text from '../../atoms/text/Text'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import { Accordion } from '../accordion/accordion'
import EmptyList from '../empty-list/EmptyList'
import { QuestionPreview } from '../../pages/assessments/Question/QuestionPreview/QuestionPreview'
import { SetCurrentAssessment } from '../../../context/AssessmentContext'

interface Props {
  assessment: API.AssessmentResponse
}

const AssessmentPreviewWithData: React.FC<Props> = ({assessment: data}) => {
  return (
    <SetCurrentAssessment assessment={data}>
      <Form>
        <Text size='lg' className='mb-4 bt-4'>{data.name}</Text>
        <VerticalGroup full wide spaceBetweenElements={4}>
          {data.groups.map((group) => {
            return <Accordion defaultState='expand' wide title={group.name} key={group.id}>
              {group.questions
            && group.questions.length === 0
            && <EmptyList message='No questions in this group' icon='risk' />}
              {group.questions
            && group.questions?.length > 0
            && group.questions.reduce((result, question, index) => {
              if (question.type === 'image' || question.type === 'written_text') {
                result.numberOfImages += 1
              }

              const preview = <QuestionPreview
                key={question.id}
                question={question}
                group={group}
                index={index - result.numberOfImages}
              />
              result.questions.push(preview)
              return result
            }, {
              questions: [] as React.ReactNode[],
              numberOfImages: 0,
            }).questions}
            </Accordion>
          })}
        </VerticalGroup> 
      </Form>
    </SetCurrentAssessment>
  )
}

export default AssessmentPreviewWithData
